export const searchPage = {
    "search_address": "Buscar la dirección del edificio",
    "search_address_sub_title": "Paga buscando la dirección exacta del edificio",
    "full_address": "Dirección completa",
    "full_address_placeholder": "Dirección completa, incluido el número del edificio",
    "search": "Buscar",
    "quick_search": "Búsqueda rápida",
    "searching": "Buscando...",
    "entrance_number": "Tu número de entrada",
    "building_not_found": "Building not found"
};
